export default __webpack_public_path__ + "static/media/member1.5dc5109d.jpg";